import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRoutes } from 'src/app/utilities/routes';
import { encryptStorage } from '../auth.service';

@Component({
    selector: 'app-auth-error',
    templateUrl: './authorization-error.component.html',
  })

  export class AuthorizationErrorComponent implements OnInit {
    constructor ( private router: Router){}
    isAuthorized = true;

  ngOnInit() {

  }
  goToLogin(){
    encryptStorage.clear();
    this.router.navigate([AuthRoutes.login]);
  }
  }
